import { render, staticRenderFns } from "./press.vue?vue&type=template&id=19e81d49&scoped=true&"
import script from "./press.vue?vue&type=script&lang=js&"
export * from "./press.vue?vue&type=script&lang=js&"
import style0 from "./press.vue?vue&type=style&index=0&id=19e81d49&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e81d49",
  null
  
)

component.options.__file = "press.vue"
export default component.exports